import * as yup from 'yup';
import dayjs from 'dayjs';

export const AtAnchorBookedDirectlyConf = {
  schema: {
    check_in_date: yup
      .mixed()
      .nullable()
      .transform((value) =>
        value && dayjs(value).isValid()
          ? dayjs(value).format('YYYY-MM-DDTHH:mm:ss')
          : null
      )
      .test('is-valid', 'Invalid date', function (value) {
        if (value) return !!dayjs(value).isValid();
        return true;
      })
      .required('Check in date is required or invalid'),
    check_out_date: yup
      .mixed()
      .nullable()
      .transform((value) =>
        value && dayjs(value).isValid()
          ? dayjs(value).format('YYYY-MM-DDTHH:mm:ss')
          : null
      )
      .test(
        'end-after-start',
        "The check out date cannot be less than the check in date",
        function (value) {
          const { check_in_date } = this.parent;

          if (!value || !check_in_date) return true;
          return dayjs.utc(value).isSameOrAfter(dayjs.utc(check_in_date));
        }
      )
      .test('is-valid', 'Invalid date', function (value) {
        if (value) return !!dayjs(value).isValid();
        return true;
      })
      .required('Check out date is required or invalid'),
    requested_dock: yup.string().nullable(),
    contact_email: yup
      .string()
      .email()
      .nullable()
      .transform((value, originalValue) => {
        // Se il campo 'contact_email' è vuoto in fase di modifica, non passarlo all'API
        return originalValue === '' ? null : value;
      }),
    contact_number: yup.string().nullable(),
    tender: yup.boolean().nullable(),
    isps: yup.boolean().nullable(),
  },
  defaultValues: {
    check_in_date: dayjs().startOf('day'),
    check_out_date: dayjs().startOf('day'),
    requested_dock: '',
    contact_email: '',
    contact_number: '',
    tender: false,
    isps: false,
  },
  fields: [
    {
      id: 'service_divider',
      type: 'divider',
      label: 'Service',
      xs: 12,
    },
    {
      id: 'check_in_date',
      name: 'check_in_date',
      type: 'date_time',
      label: 'Check in date',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'check_out_date',
      name: 'check_out_date',
      type: 'date_time',
      label: 'Check out date',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'requested_dock',
      name: 'requested_dock',
      type: 'text',
      label: 'Requested dock',
      required: false,
      xs: 12,
      sm: 6,
    },
    {
      id: 'contact_email',
      name: 'contact_email',
      type: 'text',
      label: 'Contact email',
      required: false,
      xs: 12,
      sm: 6,
    },
    {
      id: 'contact_number',
      name: 'contact_number',
      type: 'text',
      label: 'Contact number',
      required: false,
      xs: 12,
      sm: 6,
    },
    {
      id: 'tender',
      name: 'tender',
      label: 'Tender',
      type: 'switch',
      required: false,
      xs: 12,
    },
    {
      id: 'isps',
      name: 'isps',
      label: 'ISPS',
      type: 'switch',
      required: false,
      xs: 12,
    },
  ],
};
